import { useNavigate } from 'react-router-dom';

import AssessmentIcon from '@mui/icons-material/Assessment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Button from '@mui/material/Button';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import Container from '@mui/material/Container';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import HomeIcon from '@mui/icons-material/Home';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import DownloadIcon from '@mui/icons-material/Download';
import KeyIcon from '@mui/icons-material/Key';
import SmartToyIcon from '@mui/icons-material/SmartToy';

const links = [
  {
    section: 'Tools',
    label: 'Impersonate Patient',
    path: '/admin/assume-patient-role',
    Icon: KeyIcon,
  },
  {
    section: 'Tools',
    label: 'Impersonate Provider',
    path: '/admin/assume-provider-role',
    Icon: MedicalServicesIcon,
  },
  {
    section: 'Tools',
    label: 'LLM Call',
    path: '/admin/llm-call',
    Icon: SmartToyIcon,
  },
  {
    section: 'Tools',
    label: 'Scheduling',
    path: '/admin/scheduling',
    Icon: CalendarIcon,
  },
  {
    section: 'Tools',
    label: 'New Facility',
    path: '/admin/facilities/new',
    Icon: HomeIcon,
  },
  {
    section: 'Claims',
    label: 'Manage Claims',
    path: '/claims/list',
    Icon: AttachMoneyIcon,
  },
  {
    section: 'Claims',
    label: 'Process Claims',
    path: '/admin/process-claims',
    Icon: CloudUploadIcon,
  },
  {
    section: 'Leads',
    label: 'Manage Leads',
    path: '/admin/leads/list',
    Icon: NewReleasesIcon,
  },
  {
    section: 'Analytics',
    label: 'Reporting',
    path: '/admin/reports/list',
    Icon: AssessmentIcon,
  },
  {
    section: 'Analytics',
    label: 'Export Data',
    path: '/admin/data-export',
    Icon: DownloadIcon,
  },
];

const AdminHomeScreen = props => {
  const navigate = useNavigate();
  return (
    <Container>
      <Paper elevation={2} sx={{marginTop: '1em', padding: '2em'}}>
        <Stack padding={4} spacing={2} alignItems='center'>
          <Typography variant="h1">Admin Home Page</Typography>
          <Divider />
        </Stack>
        <Grid container fullWidth>
          {['Tools', 'Claims', 'Leads', 'Analytics'].map(section => 
            <Grid item xs={12} md={3} lg={3}>
              <Stack spacing={1}>
                <Typography variant="h2" align='center'>{section}</Typography>
                {
                  links.filter(l => l.section === section).map(l => 
                    <Button onClick={() => navigate(l.path)}>
                      <l.Icon sx={{marginRight: '0.25em'}}/>
                      {l.label}
                    </Button>
                  )
                }
              </Stack>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
};

export default AdminHomeScreen;
